import type { RouteRecordRaw } from 'vue-router';

const activityTemplateRoutes: RouteRecordRaw[] = [
  {
    path: '/immerse/lottery/:id',
    name: 'activityTemplateLottery',
    component: () => import('@/views/activityTemplate/lottery/index.vue'),
    meta: {
      title: '活动'
    }
  },
  {
    path: '/immerse/lottery/preview',
    name: 'activityTemplateLotteryPreview',
    component: () => import('@/views/activityTemplate/lottery/preview.vue'),
    meta: {
      title: '活动预览'
    }
  },
  {
    path: '/immerse/collect-card/:id',
    name: 'activityTemplateCollectCard',
    component: () => import('@/views/activityTemplate/collectCard/index.vue'),
    meta: {
      title: '活动'
    }
  },
  {
    path: '/immerse/collect-card/preview',
    name: 'activityTemplateCollectCardPreview',
    component: () => import('@/views/activityTemplate/collectCard/preview.vue'),
    meta: {
      title: '活动预览'
    }
  },
  {
    path: '/immerse/collect-card/share/:mode',
    name: 'activityTemplateCollectCardShare',
    component: () => import('@/views/activityTemplate/collectCard/shareCard.vue'),
    meta: {
      title: '分享卡片'
    }
  },
  {
    path: '/immerse/ad-welfare/:id',
    name: 'activityTemplateAdWelfare',
    component: () => import('@/views/activityTemplate/adWelfare/index.vue'),
    meta: {
      title: '看广告领福利'
    }
  },
  {
    path: '/immerse/ad-welfare/preview',
    name: 'activityTemplateAdWelfarePreview',
    component: () => import('@/views/activityTemplate/adWelfare/preview.vue'),
    meta: {
      title: '活动预览'
    }
  }
];

export default activityTemplateRoutes;
